export const SUSCRIPCION_PLACA_LISTAR = "SUSCRIPCION_PLACA_LISTAR";
export const SUSCRIPCION_PLACA_LISTAR_SUCCESS = "SUSCRIPCION_PLACA_LISTAR_SUCCESS";
export const SUSCRIPCION_PLACA_LISTAR_ERROR = "SUSCRIPCION_PLACA_LISTAR_ERROR";

export const listarSuscripcionPlaca = (paginacion, onSuccess) => ({
  type: SUSCRIPCION_PLACA_LISTAR,
  paginacion,
  onSuccess,
});

export const listarSuscripcionPlacaSuccess = (respuestaServidor) => ({
  type: SUSCRIPCION_PLACA_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarSuscripcionPlacaError = (errorContenido) => ({
  type: SUSCRIPCION_PLACA_LISTAR_ERROR,
  errorContenido,
});

export const GUARDAR_SUSCRIPCION_PLACA = "GUARDAR_SUSCRIPCION_PLACA";
export const GUARDAR_SUSCRIPCION_PLACA_SUCCESS = "GUARDAR_SUSCRIPCION_PLACA_SUCCESS";
export const GUARDAR_SUSCRIPCION_PLACA_ERROR = "GUARDAR_SUSCRIPCION_PLACA_ERROR";

export const guardarSuscripcionPlaca = (suscripcionPlaca,onSuccess) => ({
  type: GUARDAR_SUSCRIPCION_PLACA,
  suscripcionPlaca,
  onSuccess,
});

export const guardarSuscripcionPlacaSuccess = (respuestaServidor) => ({
  type: GUARDAR_SUSCRIPCION_PLACA_SUCCESS,
  respuestaServidor,
});

export const guardarSuscripcionPlacaError = (errorContenido) => ({
  type: GUARDAR_SUSCRIPCION_PLACA_ERROR,
  errorContenido,
});

export const PLACAS_ACTIVAS_LISTAR = "PLACAS_ACTIVAS_LISTAR";
export const PLACAS_ACTIVAS_LISTAR_SUCCESS = "PLACAS_ACTIVAS_LISTAR_SUCCESS";
export const PLACAS_ACTIVAS_LISTAR_ERROR = "PLACAS_ACTIVAS_LISTAR_ERROR";

export const listarPlacasActivas = () => ({
  type: PLACAS_ACTIVAS_LISTAR,
});

export const listarPlacasActivasSuccess = (respuestaServidor) => ({
  type: PLACAS_ACTIVAS_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarPlacasActivasError = (error) => ({
  type: PLACAS_ACTIVAS_LISTAR_ERROR,
  error,
});

export const PLANES_ACTIVOS_LISTAR = "PLANES_ACTIVOS_LISTAR";
export const PLANES_ACTIVOS_LISTAR_SUCCESS = "PLANES_ACTIVOS_LISTAR_SUCCESS"
export const PLANES_ACTIVOS_LISTAR_ERROR = "PLANES_ACTIVOS_LISTAR_ERROR";

export const listarPlanesActivos = () => ({
  type: PLANES_ACTIVOS_LISTAR,
});

export const listarPlanesActivosSuccess = (respuestaServidor) => ({
  type: PLANES_ACTIVOS_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarPlanesActivosError = (error) => ({
  type: PLANES_ACTIVOS_LISTAR_ERROR,
  error,
});

